import { orderErrorCodeOf } from '@/shared/lib';

/**
 * 주문하기 화면을 열 수 없는 사유.
 * - NOT_FOUND: 없는 견적·남의 견적(존재를 드러내지 않는다)
 * - UNAVAILABLE: 만료·발행 상태가 아닌 견적
 * - NOT_READY: 동의 문서(발행 설정 별첨 고지)가 설정되지 않음 — 서버 gate(R17 fail-closed)
 */
export type OrderPlacementBlock = 'NOT_FOUND' | 'UNAVAILABLE' | 'NOT_READY';

const BLOCK_BY_CODE: Readonly<Record<string, OrderPlacementBlock>> = {
  QUOTE_NOT_FOUND: 'NOT_FOUND',
  NOT_OWNER: 'NOT_FOUND',
  QUOTE_EXPIRED: 'UNAVAILABLE',
  QUOTE_STATE_CONFLICT: 'UNAVAILABLE',
  ORDER_STATE_CONFLICT: 'NOT_READY',
};

/** orders.getPlacement 거절의 사유. 알 수 없는 실패(통신·서버 오류)는 null — 다시 시도할 수 있다. */
export const orderPlacementBlock = (error: unknown): OrderPlacementBlock | null => {
  const code = orderErrorCodeOf(error);
  return code === null ? null : (BLOCK_BY_CODE[code] ?? null);
};
